module.exports = __webpack_public_path__ + "img/blue-circle-table-8.5e5331c0.png";